// Price formatting utility for Vietnamese Dong (VND)

/**
 * Formats a price string or number as Vietnamese Dong
 * @param price - Price as string (e.g., "2990000") or number
 * @returns Formatted price string (e.g., "₫2.990.000")
 */
export const formatVND = (price: string | number | undefined | null): string => {
  if (!price) return '';
  
  // Convert to number if it's a string
  const numPrice = typeof price === 'string' ? parseFloat(price.replace(/[^\d.]/g, '')) : price;
  
  if (isNaN(numPrice) || numPrice === 0) return '';
  
  // Format with period as thousands separator (Vietnamese standard: 2.990.000)
  // Convert number to string and add thousands separators
  const parts = numPrice.toString().split('.');
  const integerPart = parts[0];
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Return with Vietnamese Dong symbol
  return `₫${formattedInteger}`;
};

